export default {
  dictionary: {
    'coupon': 'template_coupon',
    'film': 'template_film',
    'goodsGrid': 'template_goods_grid',
    'goodsGridTab': 'template_goods_grid_tab',
    'goodsScroll': 'template_goods_scroll',
    'imgHotzone': 'template_imgHotzone',
    'navigation': 'template_navigation',
    'search': 'template_search',
    'showcase': 'template_showcase',
    'slider': 'template_slider',
    'marquees': 'template_marquees',
    'floorImg': 'template_floorImg',
    'headline': 'template_headline',
    'hotTopic': 'template_hotTopic',
    'img-gif': 'template_img-gif'
  },
  propsDictionary: {
    'coupon': 'template_editor_coupon',
    'film': 'template_editor_film',
    'goodsGrid': 'template_editor_goods_grid',
    'goodsGridTab': 'template_editor_goods_grid_tab',
    'goodsScroll': 'template_editor_goods_scroll',
    'imgHotzone': 'template_imgHotzone',
    'navigation': 'template_editor_navigation',
    'search': 'template_editor_search',
    'showcase': 'template_editor_showcase',
    'slider': 'template_editor_slider',
    'marquees': 'template_editor_marquees',
    'floorImg': 'template_editor_floorImg',
    'headline': 'template_editor_headline',
    'hotTopic': 'template_editor_hotTopic',
    'img-gif': 'template_editor_img-gif'
  },
  initData: {
    managerInitData: [
      {
        propsName: 'renderProps',
        icon: '#icon-tag',
        cnName: 'input',
        name: 'SpInput',
        type: 'formTmpsConfig',
        base: {},
        data: [
          {
            type: 'cash',
            id: '',
            amount: '50',
            imgUrl: '../../images/coupon_brand_demo.jpg',
            title: '巴黎欧莱雅',
            desc: '全场商品满900减50'
          }
        ]
      },
      {
        propsName: 'template_editor_coupon',
        icon: '#icon-tag',
        cnName: '优惠券',
        name: 'template_coupon',
        base: {
          title: '到店优惠',
          subtitle: '游客专享福利',
          padded: true
        },
        data: [
          {
            type: 'cash',
            id: '',
            amount: '50',
            imgUrl: '../../images/coupon_brand_demo.jpg',
            title: '巴黎欧莱雅',
            desc: '全场商品满900减50'
          },
          {
            type: 'discount',
            id: '',
            amount: '8',
            imgUrl: '../../images/coupon_brand_demo.jpg',
            title: '巴黎欧莱雅',
            desc: '全场商品满900减50'
          },
          {
            type: 'cash',
            id: '',
            amount: '100',
            imgUrl: '../../images/coupon_brand_demo.jpg',
            title: '巴黎欧莱雅',
            desc: '全场商品满900减50'
          }
        ]
      },
      {
        propsName: 'template_editor_film',
        icon: '#icon-video',
        cnName: '视频',
        name: 'template_film',
        base: {
          title: '',
          subtitle: '',
          padded: true,
          // 视频比例, 默认16 / 9
          proportion: 0
        },
        data: [
          {
            media_id: '',
            name: '',
            update_time: '',
            url: ''
          }
        ]
      },
      {
        propsName: 'template_editor_goods_grid',
        icon: '#icon-grid',
        cnName: '商品栅格',
        name: 'template_goods_grid',
        base: {
          title: '爆品直邮',
          subtitle: '宅家买遍全法',
          padded: true,
          listIndex: 0
        },
        config: {
          brand: true,
          showPrice: false,
          style: 'grid',
          //更多的跳转链接
          moreLink: {
            id: '',
            title: '',
            linkPage: ''
          }
        },
        //list: [],
        data: []
      },
      {
        propsName: 'template_editor_goods_grid_tab',
        icon: '#icon-grid',
        cnName: '商品Tab',
        name: 'template_goods_grid_tab',
        base: {
          title: '爆品直邮',
          subtitle: '宅家买遍全法',
          padded: true,
          listIndex: 0
        },
        config: {
          brand: true,
          showPrice: false,
          style: 'grid',
          //更多的跳转链接
          moreLink: {
            id: '',
            title: '',
            linkPage: ''
          }
        },
        list: [],
        data: []
      },
      {
        propsName: 'template_editor_goods_scroll',
        icon: '#icon-scroll',
        cnName: '商品滚动',
        name: 'template_goods_scroll',
        base: {
          title: '当地必买',
          subtitle: '看看大家都在买什么',
          padded: true,
          backgroundImg: ''
        },
        config: {
          seckillId: '',
          leaderboard: true,
          showPrice: false,
          type: 'goods',
          moreLink: {
            id: '',
            title: '',
            linkPage: ''
          }
        },
        data: [
          {
            imgUrl: '',
            title: '',
            brand: '',
            goodsId: ''
          }
        ]
      },
      {
        propsName: 'template_editor_img_hotzone',
        icon: '#icon-hotzone',
        cnName: '热区图',
        name: 'template_img_hotzone',
        base: {
          title: '热区图',
          subtitle: '图上随意画块块',
          padded: true
        },
        config: {
          imgUrl: ''
        },
        data: []
      },
      {
        propsName: 'template_editor_navigation',
        icon: '#icon-navigation',
        cnName: '图片导航',
        name: 'template_navigation',
        base: {
          padded: true
        },
        data: [
          {
            imgUrl: '../../images/jichuhufu.png',
            linkPage: '',
            content: '基础护肤',
            title: '',
            id: ''
          },
          {
            imgUrl: '../../images/caizhuangxiangshui.png',
            linkPage: '',
            content: '彩妆香水',
            title: '',
            id: ''
          },
          {
            imgUrl: '../../images/yingyangbaojian.png',
            linkPage: '',
            content: '营养保健',
            title: '',
            id: ''
          },
          {
            imgUrl: '../../images/manjianyouhui.png',
            linkPage: '',
            content: '满减优惠',
            title: '',
            id: ''
          },
          {
            imgUrl: '../../images/fenxiangpindan.png',
            linkPage: '',
            content: '分享拼单',
            title: '',
            id: ''
          }
        ]
      },
      {
        propsName: 'template_editor_search',
        icon: '#icon-search',
        cnName: '搜索',
        name: 'template_search',
        base: {
          padded: false
        },
        config: {
          fixTop: false,
          scanCode: true
        }
      },
      {
        propsName: 'template_editor_showcase',
        icon: '#icon-showcase',
        cnName: '橱窗',
        name: 'template_showcase',
        base: {
          title: '旅游资讯',
          subtitle: '',
          padded: true
        },
        config: {
          style: 1
        },
        data: [
          {
            imgUrl: '../../images/demo01.jpg',
            linkPage: '',
            content: '',
            title: '',
            id: ''
          },
          {
            imgUrl: '../../images/demo02.jpg',
            linkPage: '',
            content: '',
            title: '',
            id: ''
          },
          {
            imgUrl: '../../images/demo03.jpg',
            linkPage: '',
            content: '',
            title: '',
            id: ''
          }
        ]
      },
      {
        propsName: 'template_editor_slider',
        icon: '#icon-slider',
        cnName: '轮播',
        name: 'template_slider',
        base: {
          title: '分享拼单',
          subtitle: '分享有好礼，拼单更便宜',
          padded: true
        },
        config: {
          current: 0,
          interval: 3000,
          spacing: 0,
          dot: 'true', // 是否显示导航
          dotLocation: 'right', // 导航位置
          dotColor: 'dark', // 导航颜色
          shape: 'circle', // 导航形状 circle rectangle dot-size-switch
          numNavShape: 'rect', // 'circle' 'rectangle' 数字导航的形状
          dotCover: true, // 导航是否覆盖轮播
          rounded: false, // 轮播是否有圆角
          padded: false, // 轮播的内间距
          content: true
        },
        data: []
      },
      {
        propsName: 'template_editor_marquees',
        icon: '#icon-marquees',
        cnName: '文字轮播',
        name: 'template_marquees',
        base: {
          title: '',
          subtitle: '',
          padded: true
        },
        config: {
          direction: 'vertical',
          bgcolor: '',
          fontcolor: '',
          label: '',
          labelcolor: ''
        },
        data: []
      },
      {
        propsName: 'template_editor_floorImg',
        icon: '#icon-slider',
        cnName: '楼层图片',
        name: 'template_floorImg', //楼层图片默认数据1
        base: {
          title: '专属礼遇',
          subtitle: '看看大家都在买什么',
          padded: true,
          backgroundImg: '',
          openBackImg: false
        },
        data: []
      },
      // {
      //   name: "floorImg-two", //楼层图片默认数据2
      //   base: {
      //     title: "专属礼遇"
      //   },
      //   data: []
      // },
      {
        propsName: 'template_editor_headline',
        icon: '#icon-slider',
        cnName: '文字标题',
        name: 'template_headline', //楼层图片默认数据2
        base: {
          title: '全新作品',
          float: 'center'
        }
      },
      {
        propsName: 'template_editor_hotTopic',
        icon: '#icon-slider',
        cnName: '热点话题',
        name: 'template_hotTopic', //热点话题
        base: {
          title: '热点话题',
          index: 0
        },
        data: []
      },

      {
        propsName: 'template_editor_img-gif',
        icon: '#icon-slider',
        cnName: '视频图',
        name: 'template_img-gif', //视频图
        base: {
          title: '',
          index: 0
        },
        data: [
          {
            name: 'png',
            imgUrl: ''
          },
          {
            name: 'gif',
            imgUrl: ''
          }
        ]
      }
    ],
    formInitData: [
      // {
      //   propsName:'template_editor_coupon',
      //   icon:'#icon-tag',
      //   cnName:'优惠券',
      //   name: 'template_coupon',
      //   base: {
      //     title: '到店优惠',
      //     subtitle: '游客专享福利',
      //     padded: true
      //   },
      //   data: [
      //     {
      //       type: 'cash',
      //       id: '',
      //       amount: '50',
      //       imgUrl: '../../images/coupon_brand_demo.jpg',
      //       title: '巴黎欧莱雅',
      //       desc: '全场商品满900减50'
      //     },
      //     {
      //       type: 'discount',
      //       id: '',
      //       amount: '8',
      //       imgUrl: '../../images/coupon_brand_demo.jpg',
      //       title: '巴黎欧莱雅',
      //       desc: '全场商品满900减50'
      //     },
      //     {
      //       type: 'cash',
      //       id: '',
      //       amount: '100',
      //       imgUrl: '../../images/coupon_brand_demo.jpg',
      //       title: '巴黎欧莱雅',
      //       desc: '全场商品满900减50'
      //     }
      //   ]
      // },
      // {
      //   propsName:'template_editor_film',
      //   icon:'#icon-video',
      //   cnName:'视频',
      //   name: 'template_film',
      //   base: {
      //     title: '',
      //     subtitle: '',
      //     padded: true,
      //     // 视频比例, 默认16 / 9
      //     proportion: 0
      //   },
      //   data: [
      //     {
      //       media_id: '',
      //       name: '',
      //       update_time: '',
      //       url: ''
      //     }
      //   ]
      // },
      // {
      //   propsName:'template_editor_navigation',
      //   icon:'#icon-navigation',
      //   cnName:'图片导航',
      //   name: 'template_navigation',
      //   base: {
      //     padded: true
      //   },
      //   data: [
      //     {
      //       imgUrl: '../../images/jichuhufu.png',
      //       linkPage: '',
      //       content: '基础护肤',
      //       title: '',
      //       id: ''
      //     },
      //     {
      //       imgUrl: '../../images/caizhuangxiangshui.png',
      //       linkPage: '',
      //       content: '彩妆香水',
      //       title: '',
      //       id: ''
      //     },
      //     {
      //       imgUrl: '../../images/yingyangbaojian.png',
      //       linkPage: '',
      //       content: '营养保健',
      //       title: '',
      //       id: ''
      //     },
      //     {
      //       imgUrl: '../../images/manjianyouhui.png',
      //       linkPage: '',
      //       content: '满减优惠',
      //       title: '',
      //       id: ''
      //     },
      //     {
      //       imgUrl: '../../images/fenxiangpindan.png',
      //       linkPage: '',
      //       content: '分享拼单',
      //       title: '',
      //       id: ''
      //     }
      //   ]
      // },
    ]
  }
}
